import React from 'react';

// Subtle geometric African-inspired SVG pattern.
// Used as background watermark - opacity controlled by parent.
export default function AdinkraPattern({ className = '', color = '#0F2A5C' }) {
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="adinkra-pattern"
    >
      <defs>
        <pattern id="adinkra" x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse">
          {/* circuit-style cross + diamond - inspired by Adinkra Nyame Dua */}
          <g stroke={color} strokeWidth="1" fill="none" opacity="0.9">
            <path d="M60 18 L60 102 M18 60 L102 60" />
            <circle cx="60" cy="60" r="5" />
            <circle cx="60" cy="60" r="22" strokeDasharray="3 4" />
            <path d="M60 38 L78 60 L60 82 L42 60 Z" />
            <path d="M30 30 L30 38 M30 30 L38 30 M90 30 L90 38 M90 30 L82 30 M30 90 L30 82 M30 90 L38 90 M90 90 L90 82 M90 90 L82 90" />
          </g>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#adinkra)" />
    </svg>
  );
}
